import type { SvgIconProps } from '@mui/material/SvgIcon';

export const muiColorKeys = new Set(['inherit', 'action', 'disabled', 'primary', 'secondary', 'error', 'info', 'success', 'warning']);

export type TablerCompatIconProps = Omit<SvgIconProps, 'color' | 'size' | 'stroke' | 'strokeWidth'> & {
    size?: number | string;
    color?: string;
    stroke?: number | string;
    strokeWidth?: number | string;
};
